import '../../style/';
import '../../icon/style/'; // refer antd-mobile
import './index.less';



// WEBPACK FOOTER //
// ./components/button/style/index.tsx